import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from './session.service';
import {
  LoginPlayerRequest,
  LoginPlayerResponse,
  PlayerProfileResponse,
  RegisterPlayerRequest,
  RegisterPlayerResponse,
  UpdatePlayerProfileRequest
} from './players-api.types';

@Injectable({ providedIn: 'root' })
export class PlayerAuthApiService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  register(payload: RegisterPlayerRequest): Observable<RegisterPlayerResponse> {
    return this.http.post<RegisterPlayerResponse>(`${this.apiBaseUrl}/api/players/register`, { user: payload });
  }

  login(payload: LoginPlayerRequest): Observable<LoginPlayerResponse> {
    return this.http.post<LoginPlayerResponse>(`${this.apiBaseUrl}/api/players/login`, payload);
  }

  resendEmailVerification(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiBaseUrl}/api/players/email-verification/resend`, { email });
  }

  getMe(): Observable<PlayerProfileResponse> {
    return this.http.get<PlayerProfileResponse>(`${this.apiBaseUrl}/api/players/me`, {
      headers: this.authHeaders()
    });
  }

  updateMe(payload: UpdatePlayerProfileRequest): Observable<PlayerProfileResponse> {
    return this.http.patch<PlayerProfileResponse>(
      `${this.apiBaseUrl}/api/players/me`,
      { user: payload },
      { headers: this.authHeaders() }
    );
  }

  private authHeaders(): HttpHeaders {
    const token = this.session.token();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
